export default __webpack_public_path__ + "static/NotoSans-BlackItalic-b5f46cb2b5ce5048ba333b7e4c977626.ttf";